export default __webpack_public_path__ + "media/images/uk/about/UK_Skyline-0004db9e3b0ad09b4dd2f156409f0cb5.png";